import { render, staticRenderFns } from "./Film.vue?vue&type=template&id=23d4df04&"
import script from "./Film.vue?vue&type=script&lang=ts&"
export * from "./Film.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports